/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Button, Form, FormGroup, Label, Input, Spinner } from 'reactstrap';
import qs from 'qs';
import SelectInput from '~/components/selectInput/SelectInput';
import api from '~/services/api';
import { Container } from './styles';

function CadastroGrupoCard({
  handleSubmit,
  groupName,
  loading,
  cadastrado,
  setForm,
  form,
}) {
  const [companyData, setCompanyData] = useState([{}]);

  useEffect(() => {
    async function getData() {
      const params = {
        skip: 0,
        take: 1000,
      };
      await api
        .get(`/Pessoa/GetPessoaPaginado?${qs.stringify(params)}`)
        .then((response) => {
          const { data } = response.data;
          setCompanyData(data);
        });
    }
    getData();
  }, []);
  return (
    <Container>
      <h1>Cadastrar grupo</h1>
      <Form onSubmit={handleSubmit} style={{ width: '100%' }}>
        <FormGroup>
          <SelectInput
            margin="0"
            width="100%"
            label="Selecione a empresa"
            form={form}
            valueKey="idPessoaEmpresa"
            labelKey="razaoSocialNome"
            setForm={setForm}
            value={form.idPessoaEmpresa}
            options={companyData}
            placeholder="Escolha uma opção"
            state="idPessoaEmpresa"
            onChange={() => {}}
          />
        </FormGroup>
        <FormGroup>
          <Label>Nome do grupo</Label>
          <Input
            disabled={!!cadastrado}
            type="text"
            name="nome"
            placeholder="Nome do grupo"
            onChange={(e) => {
              setForm({ ...form, groupName: e.target.value });
            }}
            value={groupName}
          />
        </FormGroup>
        <FormGroup tag="fieldset">
          <Label>Situação cadastral</Label>
          <FormGroup check>
            <Label check>
              <Input
                type="radio"
                disabled={!!cadastrado}
                name="radio1"
                onChange={() => setForm({ ...form, situacaoCadastral: 1 })}
              />
              Ativo
            </Label>
          </FormGroup>
          <FormGroup check>
            <Label check>
              <Input
                type="radio"
                disabled={!!cadastrado}
                name="radio1"
                onChange={() => setForm({ ...form, situacaoCadastral: 2 })}
              />
              Inativo
            </Label>
          </FormGroup>
        </FormGroup>
        {loading ? (
          <Button color="primary" disabled>
            <Spinner size="sm" />
          </Button>
        ) : (
          <Button
            color="primary"
            onClick={handleSubmit}
            disabled={!!cadastrado}
          >
            Cadastrar
          </Button>
        )}
      </Form>
    </Container>
  );
}

export default CadastroGrupoCard;
